export const CONTRACT_PERIODS = [
  { text: '4 Months', value: 4 },
  { text: '6 Months', value: 6 },
  { text: '18 Months', value: 18 },
];

export const DEFAULT_VALUES = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  language: '',
  region: '',
  orderName: '',
  consentTOS: true,
  consentNewsletter: false,
  consentContract: false,
  sendEmail: false,
  insertProducts: [],
};
